import Cookies from 'universal-cookie';
import { DEFAULT_LANG, DEFAULT_MARKET } from '@rcg/ui-react';

// Its own reader rather than utils/common's: this resolves the market for the Apollo and BFF
// headers, so it has to work in every suite that stubs parts of that module.
const cookies = new Cookies();

// ui-react's currentCountry/currentLang read `wuc`/`wul` only on a production host; anywhere
// isNonProd() matches — every .stage, www.new and localhost host — they read `wuc_nonprod`/
// `wul_nonprod` instead, which no AEM site writes. They find nothing there and answer with their
// defaults, so lower and preprod always resolved the usa/en market whatever the guest had picked.
//
// Most authoritative first. `wuc`/`wul` are the brand site's own cookies, written where the guest
// actually picks the market; the other names are setMarketCookies echoing a resolved locale back,
// and on a Celebrity host it writes them host-only and session-scoped, so a stale echo would
// otherwise outrank the live choice the guest arrived with. A forced ?country= does not depend on
// this order: resolveLocale reads the query string first, and sets it aside only on a booking link
// (?token=) for a guest who already carries `wuc`.
const SITE_COUNTRY_COOKIES = ['wuc', 'wuc_nonprod'];
const COUNTRY_COOKIES = [...SITE_COUNTRY_COOKIES, 'country'];
const LANGUAGE_COOKIES = ['wul', 'wul_nonprod', 'language'];

// Literals behind the imported constants so the fallback is total. These run on every Apollo and
// BFF request, and a `@rcg/ui-react` that does not hand back both — a suite stubbing it with a bare
// factory, or a version that stops exporting them — would otherwise turn the `||` below into
// undefined.toLowerCase() instead of a market.
const FALLBACK_COUNTRY = DEFAULT_MARKET || 'usa';
const FALLBACK_LANGUAGE = DEFAULT_LANG || 'en';

const firstCookie = (names) => {
  const found = names.map((name) => cookies.get(name)).find(Boolean);
  return found === undefined ? undefined : String(found);
};

export const cookieCountry = () => (firstCookie(COUNTRY_COOKIES) || FALLBACK_COUNTRY).toLowerCase();

export const siteCountryCookie = () => firstCookie(SITE_COUNTRY_COOKIES)?.toLowerCase();

export const cookieLanguage = () =>
  (firstCookie(LANGUAGE_COOKIES) || FALLBACK_LANGUAGE).toLowerCase();
